'use strict';

/**
 * Formats a numeric threshold into Indian units.
 * Examples: 100000 -> "1 lakh", 250000 -> "2.5 lakhs", 10000000 -> "1 crore".
 *
 * @param {number|string} value - Amount to format.
 * @returns {string} formatted value
 */
function formatGuestThresholdAmount(value) {
    var num = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''));

    if (Number.isNaN(num)) {
        return String(value);
    }

    // Crores
    if (num >= 10000000) {
        var crores = num / 10000000;
        var croresText = (Math.round(crores * 10) / 10).toString().replace(/\.0$/, '');
        return croresText + (crores === 1 ? ' crore' : ' crores');
    }

    // Lakhs
    if (num >= 100000) {
        var lakhs = num / 100000;
        var lakhsText = (Math.round(lakhs * 10) / 10).toString().replace(/\.0$/, '');
        return lakhsText + (lakhs === 1 ? ' lakh' : ' lakhs');
    }

    // Fallback: plain number with Indian grouping
    try {
        return num.toLocaleString('en-IN');
    } catch (e) {
        return String(num);
    }
}

module.exports = {
    formatGuestThresholdAmount: formatGuestThresholdAmount
};
